export default __webpack_public_path__ + "static/media/flags-status.7d08afe2.svg";